module.exports = __webpack_public_path__ + "img/cattedrale_monza_hero_bg.611f46fe.png";